import { toggleActiveHandler } from './toggle-active';

export default function initMemberBookingsNavToggle() {
  const memberMakeBookingNavItem = document.getElementById(
    'member-bookings-make-booking-nav-item',
  );
  const memberBookingsNavItem = document.getElementById(
    'member-bookings-bookings-nav-item',
  );
  const memberCalendarNavItem = document.getElementById(
    'member-bookings-calendar-nav-item',
  );
  const navButtons = [
    memberMakeBookingNavItem,
    memberBookingsNavItem,
    memberCalendarNavItem,
  ].filter((button) => button);

  // add js classes to toggle side bar menu on tablet/mobile
  const mediaQuery = window.matchMedia('(max-width: 640px)');
  if (mediaQuery.matches) {
    addJSToggle(navButtons);
  }

  // add/remove js classes to toggle side bar menu on tablet/mobile when window is resized
  window.addEventListener('resize', function () {
    if (mediaQuery.matches) {
      addJSToggle(navButtons);
    } else {
      removeJSToggle(navButtons);
    }
  });

  // add active class to highlight active nav links on page load/change and hash change
  window.addEventListener('load', function () {
    toggleActiveClass(navButtons);
  });

  window.addEventListener('hashchange', function () {
    toggleActiveClass(navButtons);
  });
}

function addJSToggle(triggers) {
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', toggleActiveHandler, false);
  });
}

function removeJSToggle(triggers) {
  triggers.forEach((trigger) => {
    trigger.removeEventListener('click', toggleActiveHandler, false);
  });
}

function toggleActiveClass(buttons) {
  buttons.forEach((buttonLink) => {
    if (
      location.hash &&
      location.hash.includes(buttonLink.dataset.activeIfAnchorIncludes)
    ) {
      buttonLink.classList.add('active');
    } else {
      buttonLink.classList.remove('active');
    }
  });
}
